import { motion } from "framer-motion";
import { X, FileText } from "lucide-react";

/**
 * ImagePreview - معاينة الصورة المرفقة
 * @param {string} imagePreview - رابط الصورة
 * @param {Function} onClear - إزالة الصورة
 */
export function ImagePreview({ imagePreview, onClear }) {
  if (!imagePreview) return null;
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 10 }}
      className="mb-2 relative inline-block"
    >
      <img 
        src={imagePreview} 
        alt="Preview" 
        className="h-20 rounded-lg border border-border object-cover"
      />
      <button
        onClick={onClear}
        className="absolute -top-2 -right-2 w-6 h-6 bg-destructive text-destructive-foreground rounded-full flex items-center justify-center hover:scale-110 transition-transform"
      >
        <X className="w-3 h-3" />
      </button>
    </motion.div>
  );
}

/**
 * FilePreview - معاينة الملف المرفق
 * @param {File} file - الملف
 * @param {Function} onClear - إزالة الملف
 */
export function FilePreview({ file, onClear }) {
  if (!file) return null;
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 10 }}
      className="mb-2 relative inline-flex items-center gap-2 px-3 py-2 bg-secondary rounded-lg"
    >
      <FileText className="w-5 h-5 text-orange-500" />
      <span className="text-sm text-foreground">{file.name}</span>
      <button
        onClick={onClear}
        className="w-5 h-5 bg-destructive text-destructive-foreground rounded-full flex items-center justify-center hover:scale-110 transition-transform"
      >
        <X className="w-3 h-3" />
      </button>
    </motion.div>
  );
}

export default ImagePreview;
